export const DFY_ORDER_DEADLINE_HOURS = 24;

export function getDfyOrderName(orderExternalId: string): string {
  return `Order #${orderExternalId.slice(0, 8)}`;
}
